export default __webpack_public_path__ + "static/media/check.df8c776e.svg";